import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import clsx from 'clsx';

export function Votes({
  upvotes,
  downvotes,
  handleUpvoteButton,
  handleDownvoteButton,
  isUpvoted,
  isDownvoted,
}) {
  return (
    <>
      <button
        onClick={handleUpvoteButton}
        className={clsx('inline-flex items-center gap-2 rounded-xl p-2', [
          isUpvoted
            ? 'text-indigo-600 dark:text-indigo-400'
            : 'hover:bg-indigo-300/10 hover:text-indigo-800 dark:hover:bg-indigo-900/5 dark:hover:text-indigo-100',
        ])}
        title="upvote this"
      >
        <Icon
          className="h-[1.3em] w-[1.3em]"
          icon={
            isUpvoted
              ? 'heroicons:hand-thumb-up-solid'
              : 'heroicons:hand-thumb-up'
          }
        />
        <div>{upvotes.length}</div>
      </button>

      <button
        onClick={handleDownvoteButton}
        className={clsx('inline-flex items-center gap-2 rounded-xl p-2', [
          isDownvoted
            ? 'text-indigo-600 dark:text-indigo-400'
            : 'hover:bg-indigo-300/10 hover:text-indigo-800 dark:hover:bg-indigo-900/5 dark:hover:text-indigo-100',
        ])}
        title="downvote this"
      >
        <Icon
          className="h-[1.3em] w-[1.3em]"
          icon={
            isDownvoted
              ? 'heroicons:hand-thumb-down-solid'
              : 'heroicons:hand-thumb-down'
          }
        />
        <div>{downvotes.length}</div>
      </button>
    </>
  );
}

Votes.propTypes = {
  upvotes: PropTypes.arrayOf(PropTypes.string).isRequired,
  downvotes: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleUpvoteButton: PropTypes.func.isRequired,
  handleDownvoteButton: PropTypes.func.isRequired,
  isUpvoted: PropTypes.bool,
  isDownvoted: PropTypes.bool,
};
